import store from '../store'
export const getQueryString = (name) => {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}

// Live Chat
const getUrl = (uid, userName,lan, configId, companyName) => {
  var baseUrl = process.env.NODE_ENV === 'production' ? 'https://aspiredigital.cn' : 'https://aspiredigital.cn'
  if (lan === 'zh_cn') {
    return baseUrl + '/easemob/?configId='+ configId +'&userName=' + userName + '&companyName=' + companyName + '&openId=' + uid
  } else {
    return baseUrl + '/easemob/?configId='+ configId +'&userName=' + userName + '&companyName=' + companyName + '&openId=' + uid
  }
 
}
export const linkToChat = (lan='zh_cn', configId, companyName) => {
  var userInfo = JSON.parse(getLocalStorage(store.state.userInfo))
  var userName = userInfo.username
  var uid = getLocalStorage('openId') || userInfo.weixinOpenid
  return getUrl(uid,userName,lan,configId, companyName)
}

/**
 * 存储localStorage
 */
export const setLocalStorage = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.localStorage.setItem(name, content)
}

/**
 * 获取localStorage
 */
export const getLocalStorage = name => {
  if (!name) return
  return window.localStorage.getItem(name)
}

/**
 * 删除localStorage
 */
export const removeLocalStorage = name => {
  if (!name) return
  window.localStorage.removeItem(name)
}

/**
 * 清除localStorage
 */
export const clearLocalStorage = () => {
  window.localStorage.clear()
}

/**
 * 存储SessionStorage
 */

export const setSessionStorage = (name, content) => {
  if (!name) return
  if (typeof content !== 'string') {
    content = JSON.stringify(content)
  }
  window.sessionStorage.setItem(name, content)
}

/**
 * 获取SessionStorage
 */
export const getSessionStorage = name => {
   if (!name) return
   try {
     let Jsonname = JSON.parse(window.sessionStorage.getItem(name))
     return Jsonname
   } catch(e) {
     return window.sessionStorage.getItem(name)
   }
}

 /**
 * 删除SessionStorage
 */
export const removeSessionStorage = name => {
    if (!name) return
    window.sessionStorage.removeItem(name)
}

export const getStyle = (element, attr, NumberMode = 'int') => {
  let target
  // scrollTop 获取方式不同，没有它不属于style，而且只有document.body才能用
  if (attr === 'scrollTop') {
    target = element.scrollTop
  } else if (element.currentStyle) {
    target = element.currentStyle[attr]
  } else {
    target = document.defaultView.getComputedStyle(element, null)[attr]
  }
  // 在获取 opactiy 时需要获取小数 parseFloat
  return NumberMode === 'float' ? parseFloat(target) : parseInt(target)
}

// 防抖
export const _debounce = (fn, delay) => {

    var delay = delay || 200;
    var timer;
    return function () {
        var th = this;
        var args = arguments;
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(function () {
            timer = null;
            fn.apply(th, args);
        }, delay);
    };
}
// 节流
export const _throttle = (fn, interval) => {
    var last;
    var timer;
    var interval = interval || 200;
    return function () {
        var th = this;
        var args = arguments;
        var now = +new Date();
        if (last && now - last < interval) {
            clearTimeout(timer);
            timer = setTimeout(function () {
                last = now;
                fn.apply(th, args);
            }, interval);
        } else {
            last = now;
            fn.apply(th, args);
        }
    }
}

export const uniqueBy = (arr, key, value) => {
  const map = new Map();
  const result = [];
  for (const item of arr) {
    if (item[key] === value) {
      if (!map.has(item[key])) {
        map.set(item[key], true);
        result.push(item);
      }
    } else {
      result.push(item);
    }
  }
  return result;
};



// WEBPACK FOOTER //
// ./src/utils/index.js